import { TsrctRuleListSourcingItem } from '@/generated/gql/graphql.ts';

export enum RuleListDataGridField {
  SEQUENCE_NUMBER = 'sequenceNumber',
  NAME = 'name',
  VARIANT = 'variant',
  STATUS = 'status',
  COMMODITY_GROUP_IDS = 'commodityGroupIds',
  SOURCE_SYSTEM_IDS = 'sourceSystemIds',
  ORGANIZATION_IDS = 'organizationIds',
  RESPONSIBLE_IDS = 'responsibleIds',
  UPDATED_AT = 'updatedAt',
  CREATED_AT = 'createdAt',
  ACTIONS = 'actions',
}

export type RuleDataGridRow = TsrctRuleListSourcingItem;
